import { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Card, CardContent, CardHeader, CardTitle } from "../components/ui/card";
import { Button } from "../components/ui/button";
import { FileText, Download, Trash2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Letters() {
  const [letters, setLetters] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios.get(`${API}/letters`)
      .then(res => setLetters(res.data || []))
      .catch(() => toast.error("Failed to load letters"))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return <div className="flex items-center justify-center min-h-[400px]"><div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-orange-500"></div></div>;

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">Dispute Letters</h1>
      {letters.length === 0 ? (
        <Card className="bg-zinc-900 border-zinc-800">
          <CardContent className="py-12 text-center">
            <FileText className="h-16 w-16 mx-auto text-zinc-600 mb-4" />
            <p className="text-zinc-400">No letters generated yet</p>
          </CardContent>
        </Card>
      ) : (
        <div className="grid gap-4">
          {letters.map((letter) => (
            <Card key={letter.id} className="bg-zinc-900 border-zinc-800">
              <CardContent className="p-4 flex items-center justify-between">
                <div className="flex items-center gap-3">
                  <FileText className="h-8 w-8 text-orange-400" />
                  <div>
                    <p className="font-medium">{letter.type || 'Dispute Letter'}</p>
                    <p className="text-sm text-zinc-400">{letter.bureau} - {letter.created_at}</p>
                  </div>
                </div>
                <Button variant="ghost" size="icon">
                  <Download className="h-4 w-4" />
                </Button>
              </CardContent>
            </Card>
          ))}
        </div>
      )}
    </div>
  );
}
